export default class UserImport {
    constructor(importCSV) {
        this.login = '';
        this.password = '';
        this.name = '';
        this.surname = '';
        this.email = '';
        this.roles = [];

        if (importCSV) {
            var data = importCSV.split(',');
            if (data[0])
                this.name = data[0];
            if (data[1])
                this.surname = data[1];
            if (data[2])
                this.email = data[2];
            if (data[3])
                this.roles = data[3].split(';');
        }
    }

    toDto() {
        return {
            Login: this.login,
            Password: this.password,
            Name: this.name,
            Surname: this.surname,
            Email: this.email,
            RolesNames: this.roles
        };
    }
}